import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';
import Errordialog from '../../errordialog';

class View extends React.Component {

  state = {
    selectedControl: [],
    load: false,
    errorDialog: false
  }

  componentWillMount() {
    this.selectedMenu();
  }

  selectedMenu() {
    let data = this.props.data;
    let selectedControl = [];
    data.map((z) => {
      if (z.type == 'control') {
        if (z.id == this.props.id) {
          if (z.name == "controls") { }
          else {
            selectedControl.push(z.name)
          }
        }
      }
    })
    this.setState({ selectedControl: selectedControl })
  }

  menu = (f, { value }) => {
    this.check(value, this.state.selectedControl);
    this.setState({ selectedControl: value });
  }

  check(value, oldValue) {
    let length = value.length;
    if (length > oldValue.length) {
      let x = (value[value.length - 1]);
      this.add(x);
    } else if (length < oldValue.length) {
      let array1 = oldValue.filter(val => !value.includes(val));
      this.remove(array1[0]);
    }
  }

  remove(value) {
    let context = this;
    let data = {'id': this.props.id, 'menu': value};
    context.setState({ load: true, message: 'Removing Menu Controls!!!' })
    $.ajax({
      type: 'POST',
      data: data,
      url: Server() + 'executivemenu/remove.php',
      success: function(data)
      {
        context.setState({ load: false })
        if (data == 1) {
          context.setState({ load: false })
        }
        else {
          context.setState({ errorDialog: true, errormessage: 'Error on removing item!!!' })
        }
      },
      error: function(e)
      {
        context.setState({ load: false })
      }
    });
  }

  add(value) {
    let context = this;
    let data = {'id': this.props.id, 'menu': value};
    context.setState({
      load: true,
      message: 'Adding Menu!!!'
    })
    $.ajax({
      type: 'POST',
      data: data,
      url: Server() + 'executivemenu/insert.php',
      success: function(data)
      {
        context.setState({
          load: false,
        })
        if (data == 1) {
          context.setState({
            load: false,
          })
        }
        else {
          context.setState({
            errorDialog: true,
            errormessage: 'Error in adding items!!!'
          });
        }
      },
      error: function(e)
      {
        context.setState({
          load: false,
        })
      }
    });
  }

  closeErrorDialog() {
    this.setState({ errorDialog: false });
  }

  render() {
    
    return (
      <div>
      <Loading load={this.state.load} message={this.state.message} />
      <Errordialog load={this.state.errorDialog} message={this.state.errormessage} close={this.closeErrorDialog.bind(this)} />
      <Dropdown fluid multiple
        id="Control" onChange={this.menu}
        search selection options={this.props.menuOption}
        value={this.state.selectedControl} fluid style={{ borderColor: '#5A9CBB', fontSize: 12 }} />
      </div>
    );
  }
}

export default View;
